












import { Component } from "vue-property-decorator";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import Comments from "@/store/modules/Comments";
import CommentDisplay from "@/components/comments/CommentDisplay.vue";
import Decisions from "@/store/modules/Decisions";

const commentsModule = getModule(Comments)
const decisionModule = getModule(Decisions)
@Component({
    components: {CommentDisplay}
})
export default class CommentThreadPanel extends Vue {

    get selectedCommentResource() {
        return commentsModule.newSelectedCommentResource;
    }

    get decisionId() {
        return decisionModule.selectedDecisionId;
    }

    
}
